import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./phonepe.css";
import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import PhonepeProcess from "./PhonepeProcess";
import PhonepeStrategy from "./PhonepeStrategy";

const Phonepe = () => {
  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>PhonePe Clone App</title>

        <meta name="title" content="PhonePe Clone App Development" />
        <meta
          name="description"
          content="Get your PhonePe Clone App in no time with our expert payment app development service. Get free consultation from our fintech experts."
        />

        <meta property="og:title" content="PhonePe Clone App" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/phonepe-clone-app"
        />
      </Helmet>

      <main className="poly-main ph-main">
        {/* hero */}
        <article className="ph-hero primary__landing-content-container">
          <h1 className="ph-hero-title">PhonePe Clone App </h1>
          <p className="ph-hero-content">
            Step into digital payments era with our futuristic PhonePe Clone App
            Development services. Be the next digital payments revolutionizer.
          </p>
          <div className="text-center mt-3">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="mt-2 career-btn"
            >
              Get Free Consultation{" "}
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
          <div className="ph-hero-img">
            <img
              src={require("../../../image/phonepe/hero-img.webp")}
              alt="PhonePe Clone App"
            />
          </div>
          <img
            src={require("../../../image/phonepe/hero-float.webp")}
            className="ph-hero-float"
            alt="PhonePe Clone App"
          />
        </article>
        {/* revolution */}
        <article className="ph-mt-80 primary__landing-content-container">
          <div className="row mx-0 ph-rev-row">
            <div className="col-lg-6">
              <h3 className="ph-subtitle">
                PhonePe Clone App Revolutionizing the Digital Payment
              </h3>
              <p className="ph-subcontent">
                The world is moving toward cashless transactions, and digital
                payment platforms are at the forefront of this transformation.
                Among these, PhonePe has emerged as a trailblazer, setting
                benchmarks for convenience, security, and reliability. For
                businesses and entrepreneurs seeking to emulate this success,
                the development of a PhonePe clone app offers an unparalleled
                opportunity.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn"
              >
                Get Quote
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 ph-rev-col">
              <img
                src={require("../../../image/phonepe/rev-img.webp")}
                alt="PhonePe Clone App"
              />
            </div>
          </div>
        </article>
        {/* about */}
        <article className="ph-mt-80 ph-about">
          <div className="primary__landing-content-container">
            <div className="row mx-0 ph-about-row">
              <div className="col-lg-6 ph-about-col">
                <img
                  src={require("../../../image/phonepe/about.webp")}
                  alt="PhonePe Clone App"
                />
              </div>
              <div className="col-lg-6">
                <div className="ph-about-right">
                  <h3 className="ph-subtitle">What is a PhonePe Clone App?</h3>
                  <p className="ph-subcontent">
                    A PhonePe clone app is a customized digital payment
                    application designed to replicate the features and
                    functionalities of the PhonePe platform. It enables users to
                    perform a variety of transactions, such as sending money,
                    paying bills, recharging mobile phones, and making online
                    purchases, all within a secure and user-friendly
                    environment. Developing a PhonePe clone app allows
                    businesses to tap into the booming fintech market, offering
                    a ready-made solution with scope for customization to meet
                    specific needs.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="primary-landing-main-btn"
                  >
                    Get Quote
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* why invest */}
        <article className="ph-mt-80 primary__landing-content-container">
          <h3 className="ph-subtitle ph-invest-max">
            Why Invest in a PhonePe Clone App?
          </h3>

          <div className="why-custom-swiper">
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
                // el: ".forex-paginate",
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".why-custom-prev-arrow",
                nextEl: ".why-custom-next-arrow",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
              onSlideChange={handleSlideSecChange}
              onReachBeginning={() => setIsPrevSecDisabled(true)}
              onReachEnd={() => setIsNextSecDisabled(true)}
              onFromEdge={() => {
                setIsPrevSecDisabled(false);
                setIsNextSecDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="ph-swiper-cards-one-outer">
                  <div className="ph-swiper-cards-one">
                    <h6>Scalability and Customization</h6>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ph-swiper-btn"
                    >
                      <span className="ph-btn-txt"> Know More</span>{" "}
                      <span className="ph-btn-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ph-swiper-cards">
                  <img
                    src={require("../../../image/phonepe/invest-img-one.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Growing Demand for Digital Payment Solutions</h6>
                  <p>
                    With the increasing adoption of smartphones and internet
                    connectivity, the demand for seamless digital payment
                    solutions like PhonePe clone apps is surging.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ph-swiper-cards">
                  <img
                    src={require("../../../image/phonepe/invest-img-two.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Lucrative Monetization Opportunities</h6>
                  <p>
                    A PhonePe clone app offers multiple revenue streams,
                    including transaction fees, ads, subscription models, and
                    premium features.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ph-swiper-cards">
                  <img
                    src={require("../../../image/phonepe/invest-img-three.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Proven Business Model</h6>
                  <p>
                    PhonePe's success validates the viability of this business
                    model, making a PhonePe clone app a low-risk investment with
                    high returns.
                  </p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ph-swiper-cards">
                  <img
                    src={require("../../../image/phonepe/invest-img-four.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Scalability and Customization</h6>
                  <p>
                    A PhonePe clone app can be tailored to specific business
                    needs, offering scalability to cater to a growing user base.
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="why-custom-btn-wrapper st-key-btn-wrapper ph-swiper-btn-wrap">
              <button
                className={`why-custom-prev-arrow  ph-left-btn ${
                  isPrevSecDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevSecDisabled ? "#6E6F70" : "#0f0f0f",
                  cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`why-custom-next-arrow  ph-right-btn ${
                  isNextSecDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextSecDisabled ? "#6E6F70" : "#0f0f0f",
                  cursor: isNextSecDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </article>
        {/* Real life */}
        <article className="ph-mt-80 ph-real">
          <div className="primary__landing-content-container">
            <div className="row mx-0 g-4 ph-real-row">
              <div className="col-lg-4 col-md-12">
                <h4 className="ph-real-title">
                  Real Life Applications of a PhonePe Clone App
                </h4>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ph-swiper-btn"
                >
                  <span className="ph-btn-txt"> Know More</span>{" "}
                  <span className="ph-btn-icon">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-real-cards-outer">
                  <div className="ph-real-cards">
                    <img
                      src={require("../../../image/phonepe/real-img-one.webp")}
                      alt="PhonePe Clone App"
                    />
                    <h6>E-Commerce</h6>
                    <p>
                      Facilitate instant payments for online shopping platforms.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-real-cards-outer">
                  <div className="ph-real-cards">
                    <img
                      src={require("../../../image/phonepe/real-img-two.webp")}
                      alt="PhonePe Clone App"
                    />
                    <h6>Education</h6>
                    <p>
                      Enable fee payments for schools, colleges, and online
                      learning platforms.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-real-cards-outer">
                  <div className="ph-real-cards">
                    <img
                      src={require("../../../image/phonepe/real-img-three.webp")}
                      alt="PhonePe Clone App"
                    />
                    <h6>Healthcare</h6>
                    <p>
                      Allow quick payments for medical consultations, pharmacy
                      orders, and insurance premiums.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-real-cards-outer">
                  <div className="ph-real-cards">
                    <img
                      src={require("../../../image/phonepe/real-img-four.webp")}
                      alt="PhonePe Clone App"
                    />
                    <h6>Hospitality</h6>
                    <p>
                      Streamline hotel bookings and restaurant payments using
                      the app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-real-cards-outer">
                  <div className="ph-real-cards">
                    <img
                      src={require("../../../image/phonepe/real-img-five.webp")}
                      alt="PhonePe Clone App"
                    />
                    <h6>Transport</h6>
                    <p>
                      Integrate with taxi services, fuel stations, and public
                      transportation for cashless transactions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* key features */}
        <article className="ph-mt-80 ph-key primary__landing-content-container">
          <h3 className="ph-subtitle">Key Features of a PhonePe Clone App</h3>

          <div className="row ph-key-row">
            <div className="col-lg-5">
              <img
                src={require("../../../image/phonepe/key.webp")}
                alt="PhonePe Clone App"
                className="ph-key-img"
              />
            </div>
            <div className="col-lg-7">
              <div className="ph-key-right-outer">
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">01</span>
                    <h5 className="ph-key-right-title">Easy Onboarding</h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>
                      Quick and seamless registration via mobile number or
                      email.
                    </li>
                    <li>
                      Integration with social media accounts for instant login.
                    </li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">02</span>
                    <h5 className="ph-key-right-title">
                      Multiple Payment Options
                    </h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>
                      Support for UPI, credit/debit cards, wallets, and net
                      banking.
                    </li>
                    <li>
                      Users have flexibility to select their preferred payment
                      method.
                    </li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">03</span>
                    <h5 className="ph-key-right-title">Secure Transactions</h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>Advanced encryption and two-factor authentication.</li>
                    <li>Fraud detection mechanisms for added safety.</li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">04</span>
                    <h5 className="ph-key-right-title">QR Code Payments</h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>Easy scanning and payment via QR codes.</li>
                    <li>Simplifies offline and in-store transactions.</li>
                  </ul>
                </div>

                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">05</span>
                    <h5 className="ph-key-right-title">
                      Bill Payments and Recharges
                    </h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>
                      Support for utility bill payments, DTH, and mobile
                      recharges.
                    </li>
                    <li>Integration with multiple service providers.</li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">06</span>
                    <h5 className="ph-key-right-title">
                      {" "}
                      Cashback and Rewards System
                    </h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>Attractive offers to encourage user engagement.</li>
                    <li>Loyalty programs for repeat users.</li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">07</span>
                    <h5 className="ph-key-right-title">
                      {" "}
                      Real-Time Notifications
                    </h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>Instant updates on transaction status.</li>
                    <li>Notifications for upcoming bill payments.</li>
                  </ul>
                </div>
                <div className="ph-key-right-wrap">
                  <div className="ph-key-first">
                    <span className="ph-key-num">08</span>
                    <h5 className="ph-key-right-title"> User Wallet</h5>
                  </div>
                  <ul className="ph-key-right-list">
                    <li>Manage funds within the app.</li>
                    <li>Easy top-ups and withdrawals.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* Technical */}
        <article className="ph-mt-80 ph-technical">
          <div className="primary__landing-content-container">
            <div className="row mx-0 ph-tech-row">
              <div className="col-lg-6">
                <div className="ph-tech-left">
                  <h3 className="ph-subtitle">
                    Technical Aspects of PhonePe Clone App Development
                  </h3>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="primary-landing-main-btn mt-3"
                  >
                    Get Free Consultation
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="agile-benefit-cards card-two ph-tech-cards">
                  <img
                    src={require("../../../image/phonepe/tech-img-one.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Security Features</h6>

                  <ul>
                    <li>End-to-end encryption to protect sensitive data.</li>
                    <li>
                      Compliance with global security standards like PCI DSS.
                    </li>
                  </ul>
                </div>
                <div className="agile-benefit-cards card-three ph-tech-cards">
                  <img
                    src={require("../../../image/phonepe/tech-img-two.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Scalability</h6>
                  <ul>
                    <li>
                      Cloud-based architecture to handle increasing user loads.
                    </li>
                    <li>
                      Modular design for easy updates and feature additions.
                    </li>
                  </ul>
                </div>
                <div className="agile-benefit-cards card-four ph-tech-cards">
                  <img
                    src={require("../../../image/phonepe/tech-img-three.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>UI/UX Design</h6>
                  <ul>
                    <li>Intuitive and visually appealing interface.</li>
                    <li>
                      Optimized responsive design ensures seamless performance
                      across all devices.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* essential */}
        <article className="ph-real">
          <div className="primary__landing-content-container">
            <h3 className="ph-es-title">
              Essential Add-On Features for a PhonePe Clone App
            </h3>

            <div className="row mx-0 g-4 ph-es-row">
              <div className="col-lg-4 col-md-6">
                <div className="ph-es-odd-cards">
                  <img
                    src={require("../../../image/phonepe/es-img-one.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Multi-Language Support</h6>
                  <p>
                    Enable users to navigate the app in their preferred language
                    for better accessibility.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-es-even-cards one">
                  <h6>Chat Support</h6>
                  <p>
                    Integrate live chat features to resolve user queries
                    instantly.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-es-odd-cards">
                  <img
                    src={require("../../../image/phonepe/es-img-two.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>Split Bill Feature</h6>
                  <p>
                    Allow users to split expenses among friends or family,
                    enhancing app usability.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="ph-es-even-cards two">
                  <h6>Investment Options</h6>
                  <p>
                    Provide users with options to invest in mutual funds,
                    stocks, or cryptocurrencies directly through the app.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-es-odd-cards">
                  <img
                    src={require("../../../image/phonepe/es-img-three.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h6>AI-Powered Insights</h6>
                  <p>
                    Utilize AI to provide personalized financial tips and
                    transaction analysis to users.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ph-es-even-cards three">
                  <h6>Loyalty Card Integration</h6>
                  <p>
                    Support loyalty card management for retail purchases,
                    further engaging users.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* process */}
        <article className="ph-mt-80 primary__landing-content-container">
          <h3 className="ph-subtitle ph-process-title">
            Development Process for a PhonePe Clone App
          </h3>

          <PhonepeProcess />
        </article>
        {/* cost */}
        <article className="ph-mt-80 ph-cost">
          <div className="primary__landing-content-container">
            <h3 className="ph-subtitle text-center">
              Cost of Developing a PhonePe Clone App
            </h3>
            <p className="ph-cost-content">
              The cost of developing a PhonePe clone app depends on several
              factors
            </p>

            <div className="row mx-0 g-md-3 g-lg-0 ph-cost-row">
              <div className="col-lg-3 col-md-6">
                <div className="ph-cost-cards ph-cost-odd one">
                  <img
                    src={require("../../../image/phonepe/cost-img-one.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h5>App Complexity</h5>
                  <ul>
                    <li>The number of features and their intricacy.</li>
                    <li>Customization requirements.</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="ph-cost-cards ph-cost-even two">
                  <img
                    src={require("../../../image/phonepe/cost-img-two.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h5>Development Team</h5>
                  <ul>
                    <li>
                      Hiring a skilled team of developers, designers, and
                      testers.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="ph-cost-cards ph-cost-odd three">
                  <img
                    src={require("../../../image/phonepe/cost-img-three.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h5>Technology Stack</h5>
                  <ul>
                    <li>Choice of tools, frameworks, and platforms.</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="ph-cost-cards ph-cost-even four">
                  <img
                    src={require("../../../image/phonepe/cost-img-four.webp")}
                    alt="PhonePe Clone App"
                  />
                  <h5>Timeframe</h5>
                  <ul>
                    <li>Development duration and associated costs.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </article>
        {/* strategies */}
        <article className="ph-st">
          <div className="primary__landing-content-container">
            <h3 className="ph-subtitle ph-st-max">
              Marketing and Launch Strategies for a PhonePe Clone App
            </h3>

            <PhonepeStrategy />
          </div>
        </article>
        {/* retain */}
        <article className="ph-retain">
          <div className="primary__landing-content-container">
            <h3 className="ph-subtitle ph-st-max">
              How to Retain Users for Your PhonePe Clone App
            </h3>

            <div className="ph-retain-gallery">
              <div className="ph-box one">
                <span>
                  <div className="ph-inner-content">
                    <img
                      src={require("../../../image/phonepe/retain-img-one.webp")}
                      alt="Polymarket clone script"
                    />
                    <div>
                      <h4>Regular Updates</h4>
                      <p>
                        Continuously introduce new features and improvements to
                        keep users engaged.
                      </p>
                    </div>
                  </div>
                </span>
              </div>
              <div className="ph-box two">
                <span>
                  <div className="ph-inner-content">
                    <img
                      src={require("../../../image/phonepe/retain-img-two.webp")}
                      alt="Polymarket clone script"
                    />
                    <div>
                      <h4>Exclusive Offers</h4>
                      <p>
                        Provide discounts, cashback rewards, and promotional
                        campaigns to encourage usage.
                      </p>
                    </div>
                  </div>
                </span>
              </div>
              <div className="ph-box three">
                <span>
                  <div className="ph-inner-content">
                    <img
                      src={require("../../../image/phonepe/retain-img-three.webp")}
                      alt="Polymarket clone script"
                    />
                    <div>
                      <h4>User Education</h4>
                      <p>
                        Create tutorials and guides to help users explore the
                        app’s full potential.
                      </p>
                    </div>
                  </div>
                </span>
              </div>
              <div className="ph-box four">
                <span>
                  <div className="ph-inner-content">
                    <img
                      src={require("../../../image/phonepe/retain-img-four.webp")}
                      alt="Polymarket clone script"
                    />
                    <div>
                      <h4>Community Engagement</h4>
                      <p>
                        Build an active user community to foster trust and brand
                        advocacy.
                      </p>
                    </div>
                  </div>
                </span>
              </div>
              <div className="ph-box five">
                <span>
                  <div className="ph-inner-content">
                    <img
                      src={require("../../../image/phonepe/retain-img-five.webp")}
                      alt="Polymarket clone script"
                    />
                    <div>
                      <h4> Round-the-Clock Support</h4>
                      <p>
                        Ensure users can get help anytime through a robust
                        customer support system.
                      </p>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </article>
        {/* Take Away*/}
        <div className="custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title">Take Away</h5>
            <p className="custom-get-content">
              Developing a PhonePe clone app is a strategic move to enter the
              lucrative fintech market. With features like secure transactions,
              multiple payment options, and cashback rewards, a PhonePe clone
              app can offer unparalleled value to users while driving business
              growth. Whether you’re a startup or an established enterprise,
              investing in a PhonePe clone app can help you stay ahead in the
              digital payment revolution. Ready to bring your PhonePe clone app
              vision to life? Partner with an experienced development team today
              and unlock the potential of this thriving industry.
            </p>

            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-3"
              >
                Get Free Consultation{" "}
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is the estimated time to develop a PhonePe clone
                          app?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development timeline depends on the app’s
                          complexity but typically ranges from 4 to 6 months.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can the PhonePe clone app be customized?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, it can be fully customized to meet your business
                          requirements.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What are the essential security features of a PhonePe
                          clone app?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Key security features include encryption, two-factor
                          authentication, and compliance with PCI DSS standards.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          How can I monetize my PhonePe clone app?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          You can generate revenue through transaction fees,
                          ads, and premium subscriptions.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Is it necessary to have a technical background to
                          develop a PhonePe clone app?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          No, you can hire a professional development team to
                          handle the technical aspects.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Phonepe;
